<template>
  <v-col class="text-center py-0 d-flex flex-column justify-center align-center" :style="{minHeight: minHeight}">
    <div :class="minHeight === 'calc(100vh - 300px)' ? 'mt-10' : ''">
      <img contain :height="height" :src="require(`@/assets/empty-state/appAsset--${type}-ax.svg`)" />
      <div :class="customClass">
        <span class="d-block subtitle-2 grey-700--text" v-if="!isFree">
          <span class="d-block font-weight-bold">{{ !isFilter ? `¿Quieres ver ${id.includes('procesos') ? 'los' : ''} ${id}?` : `No ${id.includes('procesos') ? 'hay' : 'existen'} ${id} para mostrar` }}</span>
          <span v-if="hiddenDescription">{{ !isFilter ? 'Filtra para obtener registros' : 'Modifica los filtros para obtener registros'}}</span>
        </span>
        <span class="d-block subtitle-2 grey-500--text" v-else>
          <span class="d-block font-weight-bold">{{ title }}</span>
          {{ description}}
        </span>
      </div>
      <div class="mt-5">
        <slot name="actions" />
      </div>
    </div>
  </v-col>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'documents'
    },
    id: {
      type: String,
      default: 'documentos'
    },
    height: {
      type: Number,
      default: 280
    },
    count: {
      type: Number,
      default: 0
    },
    isFree: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    hiddenDescription: {
      type: Boolean,
      default: true
    },
    minHeight: {
      type: String,
      default: 'calc(100vh - 300px)'
    }
  },
  computed: {
    isFilter () {
      return this.count === 0 && Object.keys(this.$route?.query).length > 0
    }
  }
}
</script>
